import { useMediaQuery } from '../../../common/hooks/useMediaQuery'

import s from './Banner.module.css'

import bannerImage from 'assets/images/banner-frontend.jpg'

export const Banner = () => {
  const isMobile = useMediaQuery('(max-width: 430px)')

  if (isMobile) return null

  return (
    <a
      className={s.banner}
      href="https://it-incubator.io/education/front-end"
      target="_blank"
      rel="noreferrer"
    >
      <img src={bannerImage} alt="banner" />
    </a>
  )
}
